<template>
<div class="form-group col-12 col-lg-12">
    <div
        class="selectInput"
        :class="{
            'is-invalid': error,
            'form-control--filled': value
        }"
    >
        <select
            :id="uuid"
            :value="value"
            v-on:change="$emit('input', $event.target.value)"
            v-bind="ariaLabel ? { 'aria-label': ariaLabel } : {}"
        >
            <option value="" disabled selected>
                <slot></slot>
            </option>
            <option
                v-for="option in options"
                v-bind:key="option.value"
                :value="option.value"
            >
                {{ option.label }}
            </option>
        </select>
    </div>

    <slot name="description"></slot>
    <slot
        v-if="error"
        name="error"
    >
        <div class="invalid-feedback">
            Dieses Feld ist ein Pflichtfeld.
        </div>
    </slot>
</div>

</template>

<script>
import uuid from 'uuid/v1'

export default {
    name: 'SelectInput',

    props: {

        ariaLabel: {
            type: String,
            default: null
        },

        type: {
            type: String,
            default: 'text'
        },

        label: {
            type: Boolean,
            default: true
        },

        error: {
            type: Boolean,
            default: false
        },

        options: {
            type: Array,
            requires: true
        },

        value: null
    },

    data () {
        return {
            uuid: uuid()
        }
    }
}
</script>

<style>
.selectInput {
    padding-right: 5px;
    background-color: #FFFFFF;
}
.selectInput select {
  width: 100%;
  padding: 14px 20px;
  color: #004494;
  font-size: 1rem;
  outline: 0;
  border: 0;
  background: #FFFFFF;
}
select option {
    font-size: 1rem;
    color: #004494;
}
.selectInput.is-invalid {
    border: 2px solid #d11212;
}
.selectInput.is-invalid select {
    color: #d11212;
}
.selectInput.is-invalid+.invalid-feedback {
    display: block;
}
</style>



// WEBPACK FOOTER //
// src/elements/SelectInput.vue